




















































































import {
  Vue,
  servicesURL,
  headers,
  photosUrlEnum,
} from "../../constants/constants";
import { updatePhotosURL, isRTL } from "../../helpers";
import {
  BasketLoadersEnum,
  genericErrorsEnum,
} from "../../models/basket.model";
import { staticContent } from "../../localisation/detect-lang";
import { Glide, GlideSlide } from "vue-glide-js";
import axios from "axios";
    import FastAverageColor from "fast-average-color";

export default Vue.component("dish-tinder", {
  components: {
    [Glide.name]: Glide,
    [GlideSlide.name]: GlideSlide,
  },
  data() {
    return {
      staticContent,
      photosUrlEnum,
      hasError: false,
      basketLoader: BasketLoadersEnum,
      dishes: [],
      page: 1,
      size: 20,
      componentKey: 0,
      start: 0,
      shoudILoadMore: true,
      tutorial:false,
      preventClick:false  
    };
  },

  mounted() {
    this.getTinderDishes(1, this.size);
    
  },

  computed: {
    carouselOptions() {
      return {
        direction: isRTL ? "rtl" : "ltr",
        type: "carousel",
        rewind: false,
        perView: 1,
        startAt: this.start,
      };
    },
    tinderFlag() {
      return this.$root.tinderDishes;
    },

    bindConditionalClasses() {
      return this.$root.bindConditionalClasses;
    },
    isGuest() {
      return this.$root.isGuest;
    },
    basket() {
      return this.$store.getters.getBasket;
    },
    groupBasket() {
      return this.$store.state.groupBasket;
    },
    profile() {
      return this.$store.getters.getProfileData;
    },
    basketisGroup() {
      return this.$store.state.basketCompact.data.isGroup;
    },
  },
  methods: {
    detectAverageColour() {
        var list= document.getElementsByClassName("tinder-dish-img");
    for (var i = 0; i < list.length; i++) {
      let fac = new FastAverageColor();
      let container:any =list[i] ;
      fac
        .getColorAsync(container.querySelector("img"))
        .then((color) => {
          container.style.backgroundColor = color.rgba;
        })
        .catch((e) => {
          console.log(e);
        });
      }
    },
    goToResPageFromCard(dish,position) {
      if(!this.preventClick){
        window.location.href = this.itemLink(dish)
        this.preventClick=true
         window['gtag']('event', 'Dish Game: Add to Basket', {
          'event_label': 'Dish Game',
          'event_category': 'Ordering',
          'Restaurant Name':dish.restaurantName,
          'Item Name':dish.itemName,
          'Position':position,
          'Source':'Dish Card'
        });
      }
        
    },
     goToResPageFromBtn(e,dish,position) {
      if(!this.preventClick){
        e.stopPropagation()
        window.location.href = this.itemLink(dish)
        this.preventClick=true
        window['gtag']('event', 'Dish Game: Add to Basket', {
          'event_label': 'Dish Game',
          'event_category': 'Ordering',
          'Restaurant Name':dish.restaurantName,
          'Item Name':dish.itemName,
          'Position':position,
          'Source':'CTA Button'
        });
      }
    },
    
    redirectToRes(url){
        window.location.href = url

    },
    itemLink(dish) {
      return (
        this.$root.URLBuilder.restaurantURL(
          dish.restaurantName,
          dish.restaurantShortCode,
          this.$root.userCityName ? this.$root.userCityName : "cairo",
          "",
          isRTL ? "AR" : "EN"
        ) + `?item=${dish.itemUUID}`
      );
    },
    closeTinder() {
      this.$root.tinderDishes = false;
      document.body.classList.remove("modal-open");
      let newurl=window.location.pathname.replace(this.$root.dishGameState,'')
			window.history.replaceState(null, null, `${window.location.origin}${newurl}`)
      
    },
    PriceSection(sizes) {
      let newPrices = [];
      if (sizes.length > 1) {
        sizes.map((size) => {
          size.price && newPrices.push(size.price);
        });
        newPrices.length > 0 &&
          newPrices.sort(function (a, b) {
            return a - b;
          });
        let firstSize = sizes.find((size) => size.price == newPrices[0]);
        let secondSize = sizes.find(
          (size) => size.price == newPrices[sizes.length - 1]
        );
        return `<span >${firstSize.price}</span> ${staticContent.tinder.egb} -  ${secondSize.price} ${staticContent.tinder.egb}`;
      } else {
        if (sizes[0].oldPrice) {
          return `<span class='discount-tinder'>${sizes[0].price} ${staticContent.tinder.egb}</span>  <span class='old-price-tinder'>  ${sizes[0].oldPrice} ${staticContent.tinder.egb}</span> `;
        } else {
          return `<span >${sizes[0].price}</span> ${staticContent.tinder.egb}`;
        }
      }
    },
    updatePhotosURL(url, version, ext = this.photosUrlEnum.ext.JPG) {
      return updatePhotosURL(url, version, ext);
    },
    getTinderDishes(page, size) {
      axios({
        method: "GET",
        url: servicesURL.tinderDishes(this.$root.user.zoneUUID, page, size),
        headers: headers,
      })
        .then((res) => {
          if (res.data.items.length == 0) {
            this.shoudILoadMore = false;
            this.$root.tinderEntryPoint = false;
          } else {
            this.$root.tinderEntryPoint = true;

            if (page == 2) {
              this.start += this.size - 1;
            }

            if (page > 2) {
              this.start += this.size;
            }
            this.dishes = [...this.dishes, ...res.data.items];
            this.page++;
            this.reRender();
            if (res.data.items.length < this.size) {
              this.shoudILoadMore = false;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    reRender() {
      this.componentKey++;
    },

    tinderEndSlider(event) {
      if (event.direction == ">") {
        this.shoudILoadMore && this.getTinderDishes(this.page, this.size);
      }
    },
  },
});
